import "./styles/main.scss";
import "./js/app";


// WEBPACK FOOTER //
// ./src/index.js